import OrgsAndGroupsSelector from './OrgsAndGroupsSelector'

export default OrgsAndGroupsSelector
